import React from 'react';
import './Styles/SplashScreen.css';

const SplashScreen = () => {
  return (
    <div className="splash-container">
      <div className="splash-content">
        <h1 className='splash-fo'>M!M</h1>
        <p className='splash-fot'>Loading data Please wait</p>
      </div>
    </div>
  );
};

export default SplashScreen;